// extracted by mini-css-extract-plugin
export default {"root":"DetailsTableFooter_root__Vmq5U","totalHeader":"DetailsTableFooter_totalHeader__2dd9q","placeHolderShimmer":"DetailsTableFooter_placeHolderShimmer__jGg0Y"};